<template>
  <div class="container">
    <contact-bar></contact-bar>
    <navigation-bar></navigation-bar>
    <div class="block pb-4 pt-6">
      <h1
        class="has-text-centered has-text-primary"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri; font-weight: bold"
      >
        ESTAMOS LISTOS PARA HACER LA DIFERENCIA
      </h1>
      <div class="columns is-centered is-mobile">
        <div
          class="column"
          :class="width < 768 ? 'is-four-fifths' : 'is-two-thirds'"
        >
          <p
            class="has-text-primary has-text-centered is-size-6 pt-4"
            style="font-family: Calibri; font-weight: bold"
          >
            Sabemos que al inicio de cualquier proyecto surgen muchas dudas e
            interrogantes.
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6 pb-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Permítenos asesorarte y responder todas tus inquietudes.
          </p>
        </div>
      </div>
    </div>
  </div>
  <figure class="image">
    <img
      class="has-ratio"
      src="../assets/imagen_cotizaciones_alfapack.jpg"
      alt="imagen_cotizaciones_alfapack.jpg"
    />
  </figure>
  <div class="container pt-6 pb-6">
    <div class="columns">
      <div class="column" :class="width < 768 ? '' : 'is-two-fifths'">
        <h1
          class="has-text-left has-text-primary pb-4"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          COMPÁRTENOS TUS DATOS
        </h1>
        <p
          class="has-text-primary has-text-justified is-size-6 pt-4"
          style="font-family: Calibri; font-weight: bold"
        >
          Para nosotros, lo más importante es satisfacer tus necesidades.
          Nuestro equipo de atención al cliente se pondrá en contacto contigo
          para coordinar un seguimiento adecuado y proporcionarte la información
          y videos que necesitas sobre nuestros equipos. Nuestros ingenieros
          están disponibles para resolver todas tus dudas y planificar contigo
          una exitosa implementación de nuestros equipos.
        </p>
      </div>
      <div class="column" :class="width < 768 ? '' : 'is-three-fifths'">
        <p
          class="has-text-primary is-size-5 has-text-justified pt-5"
          style="font-family: Calibri; font-weight: bold"
        >
          MANOS A LA OBRA
        </p>
        <p
          class="has-text-primary is-size-6 has-text-justified"
          style="font-family: Calibri; font-weight: bold"
        >
          Llena el formulario y un asesor se pondrá en contacto contigo.
        </p>
        <form class="pt-5">
          <div class="field">
            <div class="control">
              <input class="input" placeholder="Nombre" type="text" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="Apellido" type="text" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="Empresa" type="text" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="E-mail" type="email" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="Teléfono" type="phone" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select" style="width: 100%">
                <select
                  v-model="formaContacto"
                  style="width: 100%"
                  :style="formaContacto == '' ? 'color: lightGray' : ''"
                >
                  <option class="has-text-gray" disabled selected value="">
                    Forma de contacto
                  </option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="email">E-mail</option>
                  <option value="llamada">Llamada</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select" style="width: 100%">
                <select
                  v-model="interes"
                  style="width: 100%"
                  :style="interes == '' ? 'color: lightGray' : ''"
                >
                  <option class="has-text-gray" disabled selected value="">
                    Estoy interesado en
                  </option>
                  <option value="envasado_tabletas">
                    Envasado de Tabletas
                  </option>
                  <option value="equipos_pharma">Equipos Pharma</option>
                  <option value="encartonadores_pallets">
                    Encartonadores y Pallets
                  </option>
                  <option value="codificadores">Codificadores</option>
                  <option value="selladoras_bolsas">
                    Selladoras de Bolsas
                  </option>
                  <option value="inspeccion_rayos_x">
                    Inspección por Rayos X
                  </option>
                  <option value="extractores_humo">Extractores de Humo</option>
                  <option value="servicio_refacciones">
                    Servicio y Refacciones
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="País" type="text" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="Estado" type="text" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" placeholder="Comentarios" type="text" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <label class="checkbox">
                <input type="checkbox" />
                Acepto <a href="#">Términos y condiciones</a> y
                <a href="#">Aviso de privacidad</a>
              </label>
            </div>
          </div>
          <div
            class="field is-grouped"
            :class="width < 768 ? 'is-grouped-centered' : ''"
          >
            <div class="control">
              <button
                class="button has-background-yellow has-text-white"
                style="width: 15rem"
              >
                ENVIAR
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="block">
    <div class="columns pt-6">
      <div
        class="column map-column"
        :class="width < 768 ? '' : 'is-three-fifths'"
      >
        <iframe
          height="450"
          width="100%"
          frameborder="0"
          src="https://www.google.com/maps/embed/v1/place?q=Mira+Cañada+10,+Cumbria,+Cuautitlán+Izcalli,+Estado+de+México,+México&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
        ></iframe>
      </div>
      <div
        class="column"
        :class="width < 768 ? '' : 'is-two-fifths'"
        style="background-color: #f4f4f6; max-height: 450px"
      >
        <div
          class="container"
          :style="width < 768 ? '' : 'height: 100%; padding-top: 30%'"
        >
          <h1
            class="has-text-left has-text-primary"
            :class="width < 768 ? 'is-size-3' : 'is-size-1'"
            style="font-family: Calibri; font-weight: bold"
          >
            NUESTROS HORARIOS
          </h1>
          <p
            class="has-text-primary has-text-left is-size-6 pt-2"
            style="font-family: Calibri; font-weight: bold"
          >
            Disponibles de lunes a viernes, de 9:00 a.m. a 6:00 p.m.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="columns is-centered is-mobile pb-6">
      <div
        class="column"
        :class="width < 768 ? 'is-four-fifths' : 'is-two-thirds'"
      >
        <h1
          class="has-text-centered has-text-primary"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          ESTAMOS PRESENTES EN MÉXICO, CENTROAMÉRICA, EL CARIBE
        </h1>
      </div>
    </div>
    <div class="block pb-6">
      <div class="columns is-mobile">
        <div class="column">
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            <svg-icon
              type="mdi"
              class="p-4"
              :path="mdiMapMarker"
              style="
                color: white;
                background-color: #38ac61;
                vertical-align: text-bottom;
                width: 110px;
                height: 110px;
                border-radius: 50%;
              "
            ></svg-icon>
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6 pt-4"
            style="font-family: Calibri; font-weight: bold"
          >
            ESTADO DE MÉXICO
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            contacto@alfapack.com.mx
          </p>
        </div>
        <div class="column">
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            <svg-icon
              type="mdi"
              class="p-4"
              :path="mdiMapMarker"
              style="
                color: white;
                background-color: #38ac61;
                vertical-align: text-bottom;
                width: 110px;
                height: 110px;
                border-radius: 50%;
              "
            ></svg-icon>
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6 pt-4"
            style="font-family: Calibri; font-weight: bold"
          >
            MÉRIDA
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            contacto@alfapack.com.mx
          </p>
        </div>
      </div>
    </div>
  </div>
  <contact-media></contact-media>
  <footer-component></footer-component>
</template>
<script setup lang="ts">
import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import ContactMedia from "@/components/ContactMedia.vue";
import { useWindowSize } from "vue-window-size";
import { ref } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMapMarker } from "@mdi/js";

const { width } = useWindowSize();
let formaContacto = ref("");
let interes = ref("");
</script>
